// Centralized package data with numeric prices, categories, addons availability.
// Edit prices/features here; the inquiry form auto-fills package + price + category.

export const logoPackages = [
    {
        id: "logo-basic",
        name: "Logo Basic Pack",
        priceFrom: 699,
        priceLabel: "$699",
        priceNote: "",
        category: "Logo Design",
        tier: 1,
        ribbon: null,
        description:
            "A focused starter package for businesses that need a clean, professional logo direction with essential brand foundations.",
        features: [
            "Logo Design",
            "Color Palette",
            "Typography Selection",
        ],
        addonsCategory: "branding",
        cta: "Get This Pack",
    },
    {
        id: "logo-standard",
        name: "Standard Logo Pack",
        priceFrom: 999,
        priceLabel: "$999",
        priceNote: "",
        category: "Logo Design",
        tier: 2,
        ribbon: "Most Picked",
        description:
            "A stronger logo package for brands that need more flexibility, visual depth, and better presentation across digital and print use.",
        features: [
            "Logo Design",
            "Color Palette",
            "Pattern",
            "Texture",
            "Few Brand Mockups",
            "2 Logo Variations",
        ],
        addonsCategory: "branding",
        cta: "Get This Pack",
    },
    {
        id: "logo-premium",
        name: "Premium Logo Pack",
        priceFrom: 1499,
        priceLabel: "$1,499",
        priceNote: "",
        category: "Logo Design",
        tier: 3,
        ribbon: "Best Value",
        description:
            "A complete premium logo system for businesses that want a stronger visual presence with ready-to-use brand assets.",
        features: [
            "Logo Design",
            "Color Palette",
            "Pattern",
            "Texture",
            "A Group Of Premium Mockups",
            "Social Media Kit",
            "Facebook Profile Picture",
            "Facebook Cover",
            "Instagram Profile Picture",
            "Multiple Logo Variations",
        ],
        addonsCategory: "branding",
        cta: "Get This Pack",
    },
];

export const brandingPackages = [
    {
        id: "brand-foundation",
        name: "Brand Foundation Pack",
        priceFrom: 5500,
        priceLabel: "$5,500",
        priceNote: "Starting From",
        category: "Branding",
        tier: 4,
        ribbon: null,
        description:
            "For businesses that want to move beyond just a logo and build a consistent, professional brand identity foundation.",
        features: [
            "Brand Discovery",
            "Logo System",
            "Color Palette",
            "Typography System",
            "Brand Pattern",
            "Brand Texture",
            "Visual Direction",
            "Mini Brand Guidelines",
            "Business Card Design",
            "Social Media Profile Kit",
            "5 Social Media Post Templates",
            "Basic Brand Mockup Presentation",
        ],
        addonsCategory: "branding",
        cta: "Start With This Pack",
    },
    {
        id: "brand-identity",
        name: "Brand Identity System",
        priceFrom: 15000,
        priceLabel: "$15,000",
        priceNote: "Starting From",
        category: "Branding",
        tier: 5,
        ribbon: "Most Popular",
        description:
            "A strategic identity system for growing businesses that need a premium, consistent, and scalable brand presence across every touchpoint.",
        features: [
            "Brand Strategy Session",
            "Logo System",
            "Logo Variations",
            "Color System",
            "Typography System",
            "Pattern System",
            "Texture System",
            "Icon Style Direction",
            "Brand Visual Language",
            "Full Brand Guidelines",
            "Stationery Design",
            "Social Media Kit",
            "10 Social Media Templates",
            "Brand Mockup Suite",
            "Website Visual Direction",
            "Landing Page UI Direction",
            "Presentation Style Direction",
        ],
        addonsCategory: "branding",
        cta: "Build My Brand",
    },
    {
        id: "brand-signature",
        name: "Signature Brand Ecosystem",
        priceFrom: 35000,
        priceLabel: "$35,000",
        priceNote: "Starting From",
        category: "Branding",
        tier: 6,
        ribbon: "Flagship",
        description:
            "An elite-level brand ecosystem for ambitious businesses that want to look premium, scale confidently, and dominate their market visually.",
        features: [
            "Deep Brand Strategy",
            "Competitor Visual Audit",
            "Brand Positioning Direction",
            "Complete Logo System",
            "Advanced Logo Variations",
            "Color Psychology System",
            "Typography System",
            "Pattern And Texture System",
            "Iconography Direction",
            "Visual Identity System",
            "Full Brand Guidelines",
            "Creative Direction System",
            "Social Media Brand System",
            "20 Social Media Templates",
            "Ad Banner Direction",
            "Website UI/UX Direction",
            "Landing Page Design Direction",
            "Pitch Deck Visual Direction",
            "Premium Mockup Suite",
            "Motion Logo Concept",
            "3D Brand Visual Concept",
            "Brand Launch Asset Direction",
            "Complete Digital Brand Experience Direction",
        ],
        addonsCategory: "branding",
        cta: "Create My Brand Ecosystem",
    },
];

export const allPackages = [...logoPackages, ...brandingPackages];

export const findPackageByName = (name) => allPackages.find((p) => p.name === name) || null;
